module.exports = __webpack_public_path__ + "img/vip_icon.a9497d48.png";